<template>
  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-checklist-report-photos-by-inspection-finish"
      modal
      default-pdf
      enable-generate-pdf
      enable-generate-word
      enable-setting
      enable-report-by-part
      origin="Teste de Origem"
      help="Somente serão consideradas inspeções e ambientes finalizados. Para configurar as informações do cabeçalho utilize o cadastro de empresas."
      button-title="Relatório"
      :relation-key="form.checklistId"
      java-report
      title="Relatório de Apontamentos por Inspeção">

    <template #default="{status}">

      <t-input-code-label :command="'insert'" :status="status" required enterprise
                          v-model="form.enterpriseId"
                          @change="getChecklistByEnterprise"
      />

      <t-input-search v-if="form.enterpriseId > 0"
                      v-model="form.checklistId"
                      required
                      :options="checklistOptions"
                      @change="getResumeTypeChecklistModel"
                      placeholder="Todas"
                      label="Inspeção" select/>

      <t-input label="Inspeção" v-else placeholder="Selecione um local" disabled/>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.showOccurrenceFinished" switch>
        Exibir apontamentos finalizados nesta inspeção?
      </b-form-checkbox>

      <!--      <b-row>

              <t-input cols="6" v-model="form.reportLayout" required stacked
                       :options="ReportOccurrenceLayoutType.list"
                       radio
                       label="Layout padrão"/>

              <t-input cols="6" radio required stacked v-model="form.reportGraphic"
                       :options="ReportOccurrenceGraphicType.list" label="Gráficos"/>

            </b-row>-->

      <!--      <b-row>

              <b-col cols="12" class="border-top border-bottom pt-2 pb-2">

                <b-form-checkbox v-model="form.reportByCriticality" switch>
                  Exibir status de cores por tipo de criticidade?
                  <t-help title="Utilize esta opção quando desejar informar os apontamentos por criticidade escolhida"/>
                </b-form-checkbox>

              </b-col>

            </b-row>-->


    </template>

    <template #setting>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideHeaderFooter" switch>
        Ocultar todas informações do cabeçalho e rodapé?
      </b-form-checkbox>

      <t-input-search required radio v-show="!form.reportHideHeaderFooter" v-model="form.reportHeaderPositionLogo"
                      :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>


    </template>

  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import checklistService from "@/services/modules/checklist/Checklist.service";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import ReportPositionLogoHeaderType from "@/model/types/modules/checklist/ReportPositionLogoHeaderType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import ChecklistService from "@/services/modules/checklist/Checklist.service";
import ReportOccurrenceLayoutType from "@/model/types/modules/checklist/ReportOccurrenceLayoutType";
import ReportOccurrenceGraphicType from "@/model/types/modules/checklist/ReportOccurrenceGraphicType";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportPhotoChecklistOccurrence',
  data() {
    return {
      ReportPositionLogoHeaderType,
      ReportOccurrenceLayoutType,
      ReportOccurrenceGraphicType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        enterpriseId: this.enterpriseId,
        checklistId: this.checklistId,
        reportHideHeaderFooter: false,
        showOccurrenceFinished: true,
        reportHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        reportLayout: ReportOccurrenceLayoutType.type.ONLY_FIRST_PHOTO,
        reportGraphic: ReportOccurrenceGraphicType.type.BASIC,
        reportByCriticality: false,
      },
      checklistOptions: [],
    }
  },
  props: {
    enterpriseId: Number,
    checklistId: Number,
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      if(this.enterpriseId>0) {
        this.getChecklistByEnterprise()
      }

    },

    async getChecklistByEnterprise() {

      //Limpa o checklist
      this.form.checklistId = this.checklistId

      let params = new URLSearchParams()
      params.append("enterpriseId", this.form.enterpriseId)
      params.append("status", 1)
      params.append("sorted", "issueDate desc,checklistNumber desc")
      params.append("statusChecklist", StatusChecklistType.type.FINISHED)

      await checklistService.selectList(params).then((list) => {
        this.checklistOptions = list
      }).catch(error => this.responseError(error))

    },

    async getResumeTypeChecklistModel() {


      setTimeout(async () => {

        if (this.form.checklistId > 0) {

          await ChecklistService.getResume("id", this.form.checklistId).then(async checklistResume => {

            await TypeChecklistModelService.getResume("id", checklistResume.typeChecklistId).then(resume => {

              this.form.reportHeaderPositionLogo = resume.reportOccurrenceDefaultHeaderPositionLogo
              this.form.reportHideHeaderFooter = resume.reportOccurrenceDefaultHideHeaderFooter
              this.form.reportLayout = resume.reportOccurrenceDefaultLayout
              this.form.reportGraphic = resume.reportOccurrenceDefaultGraphic
              this.form.reportByCriticality = resume.reportOccurrenceDefaultByCriticality

              if (this.form.reportHeaderPositionLogo === '') {
                this.form.reportHeaderPositionLogo = ReportPositionLogoHeaderType.type.LEFT
              }


            })

          })

        }

      }, 100)


    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
